import { useMemo } from 'react';

export default function useBankStatement(activeDraft, reviewPayload, subaccounts) {
  const bankSubaccounts = useMemo(() => {
    return subaccounts.filter(sub => {
      const code = sub.base_account?.account || String(sub.code || '');
      return code.startsWith('1110');
    });
  }, [subaccounts]);

  const liveVoucher = useMemo(() => {
    if (activeDraft?.doc_type !== 'bank_statement') return null;
    const lines = [];
    const txs = reviewPayload.transactions || reviewPayload.movements || [];
    txs.forEach(tx => {
      if (tx.matched_to_type === 'unmatched') {
        const entry = tx.suggested_entry;
        if (entry && Array.isArray(entry.lines)) {
          entry.lines.forEach(line => {
            lines.push({
              account_id: line.account_id,
              account_code: line.account_code || '',
              account_name: line.account_name || 'Cuenta no configurada',
              debit: Number(line.debit || 0),
              credit: Number(line.credit || 0),
              description: line.description || tx.description || 'Movimiento de extracto'
            });
          });
        }
      }
    });
    const grouped = {};
    lines.forEach(line => {
      const key = `${line.account_id}_${line.description}`;
      if (!grouped[key]) {
        grouped[key] = { account_id: line.account_id, account_code: line.account_code, account_name: line.account_name, debit: 0, credit: 0, description: line.description };
      }
      grouped[key].debit += line.debit;
      grouped[key].credit += line.credit;
    });
    const groupedLines = Object.values(grouped).filter(l => l.debit > 0 || l.credit > 0);
    const totalDebit = groupedLines.reduce((sum, l) => sum + l.debit, 0);
    const totalCredit = groupedLines.reduce((sum, l) => sum + l.credit, 0);
    return { lines: groupedLines, totalDebit, totalCredit, balanced: Math.abs(totalDebit - totalCredit) < 1.0 };
  }, [reviewPayload, activeDraft]);

  return { bankSubaccounts, liveVoucher };
}
